import React from 'react';
import { alpha, Box, Typography } from '@mui/material';

import { CandidateListingStatusLabel, CandidateStatus } from '@constants';
import { ICandidateDetails } from '@types';
import { normalizeCandidateStatus } from '@utils';
import { VerdictMark } from 'components/common/Verdict/Verdict';

const OUTCOME_BY_STATUS: Partial<
  Record<CandidateStatus, { passed: boolean | null; tinted: boolean }>
> = {
  [CandidateStatus.Hired]: { passed: true, tinted: true },
  [CandidateStatus.HiringApproved]: { passed: true, tinted: true },
  [CandidateStatus.Rejected]: { passed: false, tinted: false },
  [CandidateStatus.CallFailed]: { passed: false, tinted: false },
  [CandidateStatus.CandidateNoLongerAvailable]: {
    passed: null,
    tinted: false,
  },
};

export const ClosedBanner: React.FC<{ data: ICandidateDetails }> = ({
  data,
}) => {
  const status = normalizeCandidateStatus(data.status);
  const outcome = status ? OUTCOME_BY_STATUS[status] : undefined;
  if (!status || !outcome) return null;

  const reason = data.clientFeedback?.rejectionReason?.join(', ');

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.25,
        px: 2,
        py: 1.5,
        borderRadius: 1,
        backgroundColor: outcome.tinted
          ? alpha(theme.palette.highlight.scoreGreen, 0.15)
          : theme.palette.background.backgroundPrimary,
      })}
    >
      {outcome.passed !== null && (
        <Box
          sx={{
            color: outcome.passed
              ? 'highlight.scoreGreenStrong'
              : 'text.secondary',
            display: 'flex',
          }}
        >
          <VerdictMark passed={outcome.passed} />
        </Box>
      )}
      <Box minWidth={0}>
        <Typography variant="body1" fontWeight={500}>
          {CandidateListingStatusLabel[status]}
        </Typography>
        {Boolean(reason) && (
          <Typography variant="body2" color="text.secondary">
            {reason}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
